// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '../../../../common/hoc/withStyles';
import BodyCopy from '../../../../common/atoms/BodyCopy';
import Button from '../../../../common/atoms/Button';
import Modal from '../../../../common/molecules/Modal';
import { getLocator, getIconPath } from '../../../../../utils';
import styles from '../styles/BossConfirmationModal.style';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import AddedToBagActionsLabels, {
  GLOBAL_LABELS,
} from '../../AddedToBagActions/container/AddedToBagActions.labels';

const BossConfirmationModal = ({
  className,
  closeModal,
  convertItems,
  isOpen,
  message,
  buttonsRequired,
  isAfterPayFlow,
}) => {
  const labels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AddedToBagActionsLabels);
  return (
    isOpen && (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        overlayClassName="TCPModal__Overlay"
        className={`${className} TCPModal__Content`}
        fixedWidth
        contentLabel={renderLabel(
          labels.checkoutConfirmation?.lbl_checkoutmodal_continueCheckout,
          'lbl_checkoutmodal_continueCheckout'
        )}
        closeIconDataLocator="coupondetailmodalcrossicon"
      >
        <div className="modal-content">
          <div className="title-content">
            <img
              alt="notification__image"
              src={getIconPath('icons-warning-message')}
              className="notification__image elem-pr-SM"
            />
            <div>
              <BodyCopy
                fontSize="fs16"
                fontFamily="secondary"
                fontWeight="extrabold"
                data-locator={getLocator(`couponDetailModal__NameLbl`)}
              >
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    'checkout.shipping.lbl_sfs_cart_item_error',
                    AddedToBagActionsLabels
                  ),
                  'lbl_sfs_cart_item_error'
                )}
              </BodyCopy>
              <BodyCopy
                fontSize={['fs14', 'fs14', 'fs16']}
                fontFamily="secondary"
                component="span"
                fontWeight="normal"
                data-locator={getLocator(`couponDetailModal__NameLbl`)}
              >
                {message}
              </BodyCopy>
            </div>
          </div>
          <div className="button-container">
            <Button
              data-locator={getLocator('addedtobag_btncheckout')}
              className="confirmation-button back-to-bag"
              onClick={closeModal}
              spc
            >
              <BodyCopy
                component="span"
                color="blue.900"
                fontWeight="extrabold"
                fontFamily="secondary"
                fontSize={['fs13', 'fs13', 'fs14']}
                onClick={() => {}}
              >
                {renderLabel(
                  labels.checkoutConfirmation?.lbl_checkoutmodal_backToBag,
                  'lbl_checkoutmodal_backToBag'
                )}
              </BodyCopy>
            </Button>
            {buttonsRequired && !isAfterPayFlow && (
              <Button
                data-locator={getLocator('addedtobag_btncheckout')}
                className="confirmation-button confirm-checkout"
                onClick={convertItems}
                spc
              >
                <BodyCopy
                  component="span"
                  color="white"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  fontSize={['fs13', 'fs13', 'fs14']}
                  onClick={() => {}}
                >
                  {renderLabel(
                    labels.checkoutConfirmation?.lbl_checkoutmodal_continueCheckout,
                    'lbl_checkoutmodal_continueCheckout'
                  )}
                </BodyCopy>
              </Button>
            )}
          </div>
        </div>
      </Modal>
    )
  );
};
BossConfirmationModal.propTypes = {
  className: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  convertItems: PropTypes.func.isRequired,
};

BossConfirmationModal.defaultProps = {
  isOpen: false,
};

export { BossConfirmationModal as BagConfirmationModalVanilla };
export default withStyles(BossConfirmationModal, styles);
